import { atom } from 'jotai';

export const allowActingAsAllAtom = atom<boolean>(false);
export const isProxyAtom = atom<boolean>(false);
export const isLoadingGetAccessAtom = atom<boolean>(false);
